const MuiDialog = {
  styleOverrides: {
    root: {
      // Add safe area padding to the dialog container for mobile devices
      // This ensures dialogs don't overlap with status bars or navigation bars
      paddingTop: "env(safe-area-inset-top, 0px)",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    },
    paper: {
      // Reduce margin on small mobile devices (e.g., iPhone 5/SE)
      "@media (max-width: 400px)": {
        margin: "8px",
        width: "calc(100% - 16px)",
      },
      // Add additional margin on mobile to prevent content from being too close to edges
      marginTop: "16px",
      marginBottom: "16px",
    },
  },
};

export default MuiDialog;
